import { createClient } from "@supabase/supabase-js";
import { appConfig } from "./config";

export const supabase = createClient(
  appConfig.supabaseUrl || "https://placeholder.supabase.co",
  appConfig.supabasePublishableKey || "placeholder-publishable-key",
  {
    auth: {
      persistSession: true,
      autoRefreshToken: true,
      detectSessionInUrl: true,
    },
  },
);
